import React from "react";

const categoryColors = {
    "STUDENT BELIEFS": '#6A737B',
    "LEARNING BEHAVIORS": '#AA6369',
    "CLASSROOM CONTEXT": '#9BB6D2',
};

const groupedQuestions = [
    {
        group: "STUDENT LEARNING",
        rows: [
            {
                measure: 'Confidence',
                definition: "Ability beliefs about learning and achievement in the course",
                prompt: "I am good at learning the content covered in this class."
            },
            {
                measure: 'Study Habits',
                definition: "Managing time for course activities",
                prompt: "I keep up with the readings and assignments for this course."
            },
            {
                measure: 'Stress',
                definition: "Subjective evaluation of stressors at the university",
                prompt: "Sometimes I wish I could “run away” from this class."
            },
            {
                measure: 'Motivation',
                definition: "Motivation for academic activities that is self-determined by the learner",
                prompt: "In this class, I have been doing what really interests me."
            },
            {
                measure: 'Resilience',
                definition: "Ability to bounce back from setbacks",
                prompt: "I have a hard time making it through stressful things in this class."
            }
        ]
    },
    // {
    //     group: "STUDENT BELIEFS",
    //     rows: [
    //         {
    //             measure: 'Self-Efficacy',
    //             definition: "Ability beliefs about learning and achievement in the course",
    //             prompt: "I am sure about my ability to do the assignments this week for this class."
    //         },
    //         {
    //             measure: 'Value',
    //             definition: "Belief that learning content is important, useful, and enjoyable",
    //             prompt: "I like this class very much."
    //         },
    //         {
    //             measure: 'Intrinsic Motivation',
    //             definition: "Motivation for academic activities that is self-determined by the learner",
    //             prompt: "I do my classwork because I enjoy it."
    //         },
    //         {
    //             measure: 'Extrinsic Motivation',
    //             definition: "Motivation for academic activities due to external pressures",
    //             prompt: "I do my classwork because I’ll be ashamed of myself if it didn’t get done."
    //         },
    //         {
    //             measure: 'Academic Burden',
    //             definition: "Subjective evaluation of stressors at the university",
    //             prompt: "From time to time I wish I could “run away” from my situation at UNLV."
    //         }
    //     ]
    // },
    // {
    //     group: "LEARNING BEHAVIORS",
    //     rows: [
    //         {
    //             measure: 'Behavioral Engagement',
    //             definition: "Overt learning involvement",
    //             prompt: "I put effort into learning in this class."
    //         },
    //         {
    //             measure: 'Cognitive Engagement',
    //             definition: "Usage of cognitive strategies for learning",
    //             prompt: "I go through my work for this class to make sure it's right."
    //         },
    //         {
    //             measure: 'Affective Engagement',
    //             definition: "Emotional response to learning tasks",
    //             prompt: "I enjoy learning new things in this class."
    //         },
    //         {
    //             measure: 'Self-Regulation',
    //             definition: "Managing time for course activities",
    //             prompt: "I make good use of my study time for this course this week."
    //         },
    //         {
    //             measure: 'Withdrawal Intention',
    //             definition: "Intentions to withdraw from their university",
    //             prompt: "I think about leaving the university before I finish my degree."
    //         }
    //     ]
    // },
    // {
    //     group: "CLASSROOM CONTEXT",
    //     rows: [
    //         {
    //             measure: 'Autonomy',
    //             definition: "Freedom of choice and ownership in learning content & strategies",
    //             prompt: "What I do in this class reflects what I really want."
    //         },
    //         {
    //             measure: 'Relatedness',
    //             definition: "Perception of connectedness to others",
    //             prompt: "The people in this class I care about also care about me."
    //         },
    //         {
    //             measure: 'Cultural Congruity',
    //             definition: "Perception of cultural values and practices aligned or supported",
    //             prompt: "I feel that, in this class, I have to change myself to fit in."
    //         },
    //         {
    //             measure: 'Belongingness',
    //             definition: "Sense of acceptance, inclusion, and connection",
    //             prompt: "Other students in this class take my opinions seriously."
    //         }
    //     ]
    // }
];

const QuestionTable = () => {
    return (
      <div>
        <table className="question-table">
          <thead>
            <tr className="step-overview-3">
              <th>Measure Name</th>
              <th>Definition</th>
              <th>Survey Sample Item</th>
            </tr>
          </thead>
          <tbody>
            {groupedQuestions.map((group) => (
              <React.Fragment key={group.group}>
                <tr className="group-row">
                  <td colSpan="3" style={{ color: categoryColors[group.group] }}>{group.group}</td>
                </tr>
                {group.rows.map((q) => (
                  <tr key={q.measure}>
                    <td style={{ color: categoryColors[group.group] }}>{q.measure}</td>
                    <td>{q.definition}</td>
                    <td>{q.prompt}</td>
                  </tr>
                ))}
              </React.Fragment>
            ))}
          </tbody>
        </table>
      </div>
    );
};

export default QuestionTable;
